import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const TeamCardExpiryBanner = lazy(() => import('.'))

const RootProviders = lazy(() => import('@app/components/AppProviders'))

class TeamCardExpiryBannerWebComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['days-until-expiry']
  }

  override render() {
    const daysUntilExpiry = this.prop('days-until-expiry')

    return (
      <RootProviders>
        <TeamCardExpiryBanner daysUntilExpiry={Number(daysUntilExpiry)} />
      </RootProviders>
    )
  }
}

customElements.define('team-card-expiry-banner', TeamCardExpiryBannerWebComponent)
